export default {
  "logoLink": "https://www.chinese-atfx.com/uk/",//修改该参数请在/static/lang.js也需修改
  "FCA_License_No": "FCA 许可证",//修改该参数请在/static/lang.js也需修改
  "headTtitle": "外汇交易真实账户_CFD差价合约交易真实账户_开设外汇账户优势 - ATFX.COM",//修改该参数请在/static/lang.js也需修改
  "topFixedBanner": "差价合约是复杂的金融交易产品，可带来由杠杆作用而导致迅速亏损的高风险。 大部分的零售投资者帐户在跟交易差价合约时录得资金亏损。您应当考虑您是否充分明白差价合约如何运作，以及您是否能承受您的资金损失的高风险。",//修改该参数请在/static/lang.js也需修改
  "topFixedBannerShort": "59.38% 的零售投资者帐户在跟这个供应商交易差价合约时录得资金亏损。",//修改该参数请在/static/lang.js也需修改
  "headDescription": "外汇开户首选ATFX，正规外汇平台英国FCA监管。FCA 监管号：760555，交易安全可靠、致力于为快速增长的客户提供外汇、贵金属、指数、差价合约和原油交易的服务。",
  "policyBarClose": '公司已决定不再面向零售客户提供服务, 即时生效。故此不再接受零售客户开户申请。<br />对专业客户的服务将不受影响。申请专业客户请联系<a href="mailto:cs.uk@atfx.com">cs.uk@atfx.com</a>',
  "policyBar":'我们使用cookie以确保您在我们的网站获得最佳体验。继续浏览本网站即表示您同意我方使用cookie。 <a title="【详情】" href="https://www.chinese-atfx.com/uk/wp-content/uploads/sites/5/2019/04/cookies-policy-uk-cn.pdf" target="_blanck">【详情】</a>',
  "policyBarButton":'同意',
  "header": {
    "registration": "开户申请",
    "personalDetails1": "个人资料1",
    "personalDetails2": "个人资料2",
    "financialDetails": "财务细节",
    "Experience": "经验",
    "Knowledge": "知识",
    "Acknowledgements": "确认",
    "previewPage":"预览",
    "liveTrading": "真实交易"
  },
  footer:{//修改该参数请在/static/lang.js也需修改
    "copyright":"© 2020 ATFX.COM. 版权所有。",
    "terms1":'<a href="http://www.chinese-atfx.com/uk/wp-content/uploads/sites/5/2019/04/privacy-policy-uk-cn.pdf" target="_blank" rel="noopener">隐私政策</a>',
    "terms2":'<a href="http://www.chinese-atfx.com/uk/wp-content/uploads/sites/5/2019/04/cookies-policy-uk-cn.pdf" target="_blank" rel="noopener">Cookies 政策</a>',
    "terms3":'<a href="http://www.chinese-atfx.com/uk/wp-content/uploads/sites/5/2019/04/standard-terms-uk-cn.pdf" target="_blank" rel="noopener">条款和条件</a>',
    "Legal":" 法律声明: AT Global Markets (UK) Limited 为一家英国公司（公司注册号：09827091），由英国金融行为监管局（FCA）授权并受其监管（FCA监管号：760555）。注册地址是：1st Floor, 32 Cornhill, London, EC3V 3SG, United Kingdom。",
    "riskWaring":'高风险投资警告: 差价合约是复杂的金融交易产品，可带来由于杠杆作用而导致迅速亏损的高风险。 <strong>59.38% 的零售投资者帐户在跟这个供应商交易差价合约时录得资金亏损。</strong>您应当考虑您是否充分明白差价合约如何运作，以及您是否能承受您的资金损失的高风险。请阅读<a title="风险披露政策" href="https://www.chinese-atfx.com/uk/wp-content/uploads/sites/5/2019/04/standard-terms-uk-cn.pdf" target="_blanck">风险披露政策</a>.',
    "otherInfo":"本网站的信息不针对美国、比利时或英国境外任何特定国家的居民，也不得向当地法律法规禁止传播或使用此信息的任何国家或地区的任何人传播此信息或供其使用此信息。"
  },
  "headerMsg": {
    "personalDetails1": "当提交以下信息，将表示确认并同意ATFX 的<a href='http://www.chinese-atfx.com/uk/wp-content/uploads/sites/5/2019/04/standard-terms-uk-cn.pdf' target='_blank'>商业条款</a>和<a href='http://www.chinese-atfx.com/uk/wp-content/uploads/sites/5/2019/04/privacy-policy-uk-cn.pdf' target='_blank'>隐私政策</a>，ATFX会基于申请表的细节与我联系。",
    "personalDetails2": "当提交以下信息，将表示确认并同意ATFX 的<a href='http://www.chinese-atfx.com/uk/wp-content/uploads/sites/5/2019/04/standard-terms-uk-cn.pdf' target='_blank'>商业条款</a>和<a href='http://www.chinese-atfx.com/uk/wp-content/uploads/sites/5/2019/04/privacy-policy-uk-cn.pdf' target='_blank'>隐私政策</a>，ATFX会基于申请表的细节与我联系。",
    "financialDetails": "作为FCA授权及监管的公司，我们有责任评估我们的产品是否适合您。您提供的答案将成为我们能否为您提供服务的依据。",
    "experience": "作为FCA授权及监管的公司，我们有责任评估我们的产品是否适合您。您提供的答案将成为我们能否为您提供服务的依据。",
    "knowledge": "作为FCA授权及监管的公司，我们有责任评估我们的产品是否适合您。您提供的答案将成为我们能否为您提供服务的依据。",
    "acknowledgements": "完成提交本开户表，即确认您已明白保证金外汇及差价合约是杠杆产品, 并会为您的投资本金带来高风险。您确认已知悉监控账户情况属本人的责任，且产品性质本身导致您可能会损失超过初始投资额。"
  },
  "changeLanguage": "切换语言",
  "back": "上一页",
  "next": "下一页",
  "finish": "完成",
  "personalDetails1": {
    "estimatedTime":"预计完成注册的时间为5分钟",
    "Gender": "性别",
    "genderSelect": {
      "M": "男士",
      "F": "女士",
      "O":"其他"
    },
    "OtherGender":"其他性别",
    "Title": "称谓",
    "titleSelect":{
      "Mr":"先生(Mr.)",
      "Mrs":"太太(Mrs)",
      "Ms":"女士(Ms)",
      "Miss":"小姐(Miss)",
      "Dr":"博士(Dr)",
      "Other":"其他"
    },
    "OtherTitle":"其他称谓",
    "First_Name": "名",
    "Surname": "姓",
    "Email": "电子邮箱地址",
    "Email_Confirm": "确认邮箱地址",
    "Lang": "邮箱语言",
    "emailLanguages": {
      "ENG": "英文",
      "CHT": "繁体中文",
      "CHS": "简体中文",
      "ARA": "阿拉伯文",
      "ESP": "西班牙语",
      "ITA": "意大利语",
      "GER": "德语",
      "PTG": "葡萄牙语"
    },
    "MT4_Currency":"交易账户币种",
    "MT4CurrencySelect":{
      "USD":"(USD) 美元",
      "GBP":"(GBP) 英镑",
      "EUR":"(EUR) 欧元"
    },
    "Account_Type": "MT4账户类型",
    "Account_TypeSelect": {
      "CFDs": "CFDs",
      "SpreadBetting": "点差交易"
    },
    "Country": "居住地",
    "countrySelect": {
      "USA": "美国",
      "HKG": "中国香港",
      "GBR":"英国",
      "CHN":"中国",
      "TWN":"中国台湾",
      "ARE":"阿联酋",
      "ALB":"阿尔巴尼亚",
      "AND":"安道尔",
      "AIA":"安圭拉",
      "ATG":"安提瓜和巴布达",
      "ARG":"阿根廷",
      "ARM":"亚美尼亚",
      "ABW":"阿鲁巴",
      "AUS":"澳大利亚",
      "AUT":"奥地利",
      "AZE":"阿塞拜疆",
      "BHS":"巴哈马",
      "BHR":"巴林",
      "BGD":"孟加拉国",
      "BRB":"巴巴多斯",
      "BLR":"白俄罗斯",
      "BEL":"比利时",
      "BLZ":"伯利兹",
      "BEN":"贝宁",
      "BMU":"百慕大",
      "BOL":"玻利维亚",
      "BWA":"博茨瓦纳",
      "BVT":"布韦岛",
      "BRA":"巴西",
      "BRN":"文莱",
      "BGR":"保加利亚",
      "BFA":"布基纳法索",
      "BDI":"布隆迪",
      "KHM":"柬埔寨",
      "CMR":"喀麦隆",
      "CPV":"佛得角",
      "CYM":"开曼群岛",
      "CAF":"中非",
      "TCD":"乍得",
      "CHL":"智利",
      "CCK":"科科斯群岛",
      "COL":"哥伦比亚",
      "COM":"科摩罗",
      "COK":"库克群岛",
      "CRI":"哥斯达黎加",
      "CIV":"科特迪瓦",
      "HRV":"克罗地亚",
      "CUB":"古巴",
      "CYP":"塞浦路斯",
      "CZE":"捷克",
      "DNK":"丹麦",
      "DJI":"吉布提",
      "DMA":"多米尼克",
      "DOM":"多米尼加",
      "EGY":"埃及",
      "SLV":"萨尔瓦多",
      "ERI":"厄立特里亚",
      "EST":"爱沙尼亚",
      "ETH":"埃塞俄比亚",
      "FJI":"斐济",
      "FIN":"芬兰",
      "PYF":"法属波利尼西亚",
      "GAB":"加蓬",
      "GEO":"格鲁吉亚",
      "DEU":"德国",
      "GHA":"加纳",
      "GIB":"直布罗陀",
      "GRC":"希腊",
      "GRL":"格陵兰",
      "GRD":"格林纳达",
      "GLP":"瓜德罗普",
      "GTM":"危地马拉",
      "GIN":"几内亚",
      "GNB":"几内亚比绍",
      "HTI":"海地",
      "HMD":"赫德岛和麦克唐纳群岛",
      "HND":"洪都拉斯",
      "HUN":"匈牙利",
      "ISL":"冰岛",
      "IND":"印度",
      "IDN":"印尼",
      "IRL":"爱尔兰",
      "ISR":"以色列",
      "ITA":"意大利",
      "JAM":"牙买加",
      "JPN":"日本",
      "JOR":"约旦",
      "KAZ":"哈萨克斯坦",
      "KEN":"肯尼亚",
      "KIR":"基里巴斯",
      "KOR":"南韩",
      "KWT":"科威特",
      "KGZ":"吉尔吉斯斯坦",
      "LVA":"拉脱维亚",
      "LSO":"莱索托",
      "LBR":"利比里亚",
      "LBY":"利比亚",
      "LIE":"列支敦士登",
      "LTU":"立陶宛",
      "LUX":"卢森堡",
      "MAC":"中国澳门",
      "MDG":"马达加斯加",
      "MWI":"马拉维",
      "MYS":"马来西亚",
      "MDV":"马尔代夫",
      "MLI":"马里",
      "MLT":"马耳他",
      "MHL":"马绍尔群岛",
      "MTQ":"马提尼克",
      "MUS":"毛里求斯",
      "MYT":"马约特",
      "MEX":"墨西哥",
      "MDA":"摩尔多瓦",
      "MCO":"摩纳哥",
      "MNG":"蒙古",
      "MNE":"黑山",
      "MSR":"蒙特塞拉特",
      "MAR":"摩洛哥",
      "MOZ":"莫桑比克",
      "NAM":"纳米比亚",
      "NRU":"瑙鲁",
      "NLD":"荷兰",
      "NCL":"新喀里多尼亚",
      "NZL":"新西兰",
      "NIC":"尼加拉瓜",
      "NER":"尼日尔",
      "NGA":"尼日利亚",
      "NIU":"纽埃",
      "NFK":"诺福克岛",
      "NOR":"挪威",
      "OMN":"阿曼",
      "PAK":"巴基斯坦",
      "PSE":"巴勒斯坦",
      "PRY":"巴拉圭",
      "PER":"秘鲁",
      "PHL":"菲律宾",
      "PCN":"皮特凯恩群岛",
      "POL":"波兰",
      "PRT":"葡萄牙",
      "QAT":"卡塔尔",
      "ROU":"罗马尼亚",
      "RUS":"俄罗斯",
      "RWA":"卢旺达",
      "SHN":"圣赫勒拿",
      "KNA":"圣基茨和尼维斯",
      "LCA":"圣卢西亚",
      "SPM":"圣皮埃尔和密克隆",
      "VCT":"圣文森和格林那丁",
      "WSM":"萨摩亚",
      "SMR":"圣马力诺",
      "STP":"圣多美和普林西比",
      "SAU":"沙特阿拉伯",
      "SEN":"塞内加尔",
      "SRB":"塞尔维亚",
      "SYC":"塞舌尔",
      "SLE":"塞拉利昂",
      "SGP":"新加坡",
      "SVK":"斯洛伐克",
      "SVN":"斯洛文尼亚",
      "ZAF":"南非",
      "ESP":"西班牙",
      "SUR":"苏里南",
      "SJM":"斯瓦尔巴群岛和扬马延岛",
      "SWZ":"斯威士兰",
      "SWE":"瑞典",
      "CHE":"瑞士",
      "TJK":"塔吉克斯坦",
      "TZA":"坦桑尼亚",
      "THA":"泰国",
      "TLS":"东帝汶",
      "TGO":"多哥",
      "TON":"汤加",
      "TTO":"特立尼达和多巴哥",
      "TUN":"突尼斯",
      "TUR":"土耳其",
      "TKM":"土库曼斯坦",
      "TCA":"特克斯和凯科斯群岛",
      "TUV":"图瓦卢",
      "UKR":"乌克兰",
      "URY":"乌拉圭",
      "UZB":"乌兹别克斯坦",
      "VUT":"瓦努阿图",
      "VAT":"梵蒂冈",
      "VEN":"委内瑞拉",
      "VNM":"越南",
      "WLF":"瓦利斯和富图纳",
      "ESH":"西撒哈拉",
      "ZMB":"赞比亚",
      "DZA": "阿尔及利亚",
      "AGO": "安哥拉",
      "BIH": "波斯尼亚和黑塞哥维那",
      "GMB": "冈比亚",
      "GUY": "圭亚那",
      "IRQ": "伊拉克",
      "RKS": "科索沃",
      "LBN": "黎巴嫩",
      "MKD": "马其顿",
      "NPL": "尼泊尔",
      "PAN": "巴拿马",
      "PNG": "巴布亚新几内亚",
      "LKA": "斯里兰卡"
    },
  },
  "personalDetails2": {
    "Addr": "地址 1",
    "Addr2": "地址 2",
    "City": "城市",
    "Postcode": "邮政编码",
    "Building_Name": "楼房编号/名称",
    "Street": "街道",
    "Province": "省份",
    "birthDate": "出生日期",
    "birthYear": "年",
    "birthMonth": "月",
    "birthSecond": "日",
    "Nationality": "证件签发地",
    "isHavePass": "请问是否持有所选择国籍的护照",
    "PotSelect": {
      "havePot": "有",
      "noPot": "否"
    },
    "NAT_ID": "护照号码",
    "Phone": "电话",
    "countryPlace": "居住地",
    "TIN": "TIN (纳税人识别号码)",
    "Doc_Type": "证件类型",
    "idTypeSelect": {
      "POT": "护照",
      "IDC": "身份证",
      "DRI": "驾照"
    },
    "Doc_No": "证件号码",
    "bankCardType": "银行卡类型",
    "bankCardTypeSelect": {
      "DR": "借记卡",
      "CR": "信用卡"
    },
    "Addr_Country":"地址所在国家",
    "Bank_Card_No": "银行卡号",
    "bankCardNoConfirm": "银行卡号确认",
    "Bank": "银行",
    "bankSelect": {
      "ICBK": "中国工商银行",
      "ABOC": "中国农业银行",
      "PCBC": "中国建设银行",
      "BKCH": "中国银行",
      "CMBC": "招商银行",
      "COMM": "交通银行",
      "MSBC": "中国民生银行",
      "EVER": "中国光大银行",
      "SPDB": "上海浦东发展银行",
      "FJIB": "兴业银行",
      "CIBK": "中信银行",
      "PSBC": "中国邮政储蓄银行",
      "SZCB": "平安银行",
      "GDBK": "广东发展银行",
      "BOSH": "上海银行",
      "BJCN": "北京银行",
      "HXBK": "华夏银行",
      "other": "其他"
    },
    "OtherBank": "其它银行",
    "Beneficiary_Name": "收款人",
    "SWIFT_Code": "SWIFT编码",
    "Branch_Name": "银行支行名称",
    "Bank_Addr": "银行分行地址",
    "Branch_Province": "银行分行省份",
    "Branch_City": "银行分行城市",
    "bankCardImg": "银行卡附件",
    "IBAN_Code":"IBAN编码",
    "docFrontImgword": "证件照片（正面）",
    "docBackImgword": "证件照片（反面）",
    "addressUpload": "地址证明",
    "addressUpload2": "地址证明2",
    "addressUploadTxt1": "可用证明 : 3个月之内的水电费清单 / 煤气费单 / 银行对账单 / 暂住证 / 驾驶证 / 身份证 / 户口本（如申请人不是户主，需要连同户主的页面合并为1张图片后提交）；",
    "addressUploadTxt2": "地址证明不得与身证证明相同。",
    "docImgword1": "证件附件1",
    "docImgword2": "证件附件2",
    "docImgword3": "证件附件3",
    "docImgword4": "证件附件4",
    "docImgword5": "证件附件5",
    "fileUpload":{
      "imgtUpload": "上传",
      "uploadFileArr": [{
        "labelTxt": "身份附件1",
        "ValidateNull": "请选择",
        "sizeLimit": "身份附件1不能超过5MB!"
      }, {
        "labelTxt": "身份附件2",
        "ValidateNull": "请选择",
        "sizeLimit": "身份附件2不能超过5MB!"
      }, {
        "labelTxt": "地址证明",
        "ValidateNull": "请选择",
        "sizeLimit": "请选择地址证明附件大小应小于5MB!"
      },{
        "labelTxt": "地址证明2",
        "ValidateNull": "请选择",
        "sizeLimit": "请选择地址证明附件大小应小于5MB!"
      },{
        "labelTxt": "其他文件",
        "ValidateNull": "请选择",
        "sizeLimit": "请选择附件大小应小于5MB!"
      }],
      "addressUploadHtml": {
        "sizeLimit":"档案大小不可超过5MB",
        "upload_your_documents":"上传您的身份证件",
        "documents_not_ready":"文件还没有准备好?",
        "noe": "*申请人必须提供身份证件图片和地址证明以核实身份。我们不接受：手机账单，信用卡账单或任何移动服务账单;保险收据;购买商品/服务的发票。",
        "noe2": "如果您现在没有所需的文件，您仍然可以完成申请。<br/><b>但是，在我们收到所需文件之前，您将无法进行交易。<b/>",
        "header1": "身份证明 (最少提交$Logic份)",
        "list1": "我们要求政府签发的身份证/护照文件的彩色副本。对于身份证件，我们需要证件的正面和背面。",
        "list1_new":"我们要求护照正本的清晰彩色复印本，而且需清楚看到护照的四个角。",
        "header2": "地址证明 (请从下列选项中提交$Logic份)",
        "list2": "<ol class='list-style-position:inside'><li>近3个月内发出的物业账单(水/电/煤气), </li><li>近3个月由银行发出的对账单，</li><li>我们可以接受中国的户口本和房产证，但须经过审核。 </li><li>当前的租赁协议以及近3个月内支付的物业账单（煤气/水/电）。 </li><li>在过去6个月内发布的税单。 </li><li>在过去3个月内发出的固定电话账单。 </li></ol>",
        "strongTxt": "<strong>作为我们监管要求的一部分，我们可能会要求您提供有关申请的其他文件。</strong>"
      }
    },
    "isHaveCitizen": "你是美国的公民吗？",
    "CitizenSelect": {
      "Y": "是",
      "N": "否"
    },
    "citizen_Tip":"Unfortunately we cannot open an account for US citizens",
    "isDualCitizenship": "您是居住在您所在国家以外的任何地方的税务居民吗?",
    "DualCitizenshipSelect": {
      "Y": "是",
      "N": "否"
    },
    "Dual_Nationality":"国家",
    "IS_Politically_Person": "您是政治公众人物吗？",
    "IS_Politically_Exposed":'"政治公众人物" 是指在共和国或其他国家中，正在或曾经担当重要公共职能的自然人，或其直系亲属，或已知与其有密切联系的人：<br/>此定义中的 "重要公共职能" 是指下列任何公共职能：<br/>（a）国家元首、政府首脑、部长、副部长或助理部长；<br/>（b）议会或类似立法机关的成员；<br/>（c）政党理事组织的成员；<br/>（d）最高法院、宪法法院或其他高级司法机关（不得就其判决或裁定提起上诉，特殊情况除外）的成员；<br/>（e）审计院或中央银行董事会的成员；<br/>（f）大使、代办以及武装部队中的高级官员；<br/>（g）国有企业的行政、管理或监督机构成员；<br/>（h）国际组织理事会或同等机构的理事、副理事和成员；<br/>（i）市长，<br/>进一步而言，（a）至（i）中所提及的公共职能，不应理解为涵盖中级或其他初级的官员；<br/>另一方面，"政治公众人物" 的近亲属包括：<br/>（a）政治公众人物的配偶或被视为等同于配偶的人；<br/>（b）政治公众人物的子女及其配偶、或被视为等同于其子女配偶的人；<br/>（c）政治公众人物的父母；<br/>"已知与政治公众人物有密切联系的人" 是指下列自然人：<br/>（a）已知该自然人与政治公众人物就法律实体、法律安排或任何其他密切商业关系拥有共同的实益所有权；<br/>（b）该自然人就法律实体或法律安排拥有单独的实益所有权，但已知该法律实体或法律安排实际上是为了政治公众人物的利益而设立的。',
    "IS_Politically_Person_Select": {
      "Y": "是",
      "N": "否"
    },
  },
  "financialDetails": {
    "Emp_Status": "就业状态",
    "employmentStatusSelect": {
      "b": "受雇",
      "a": "自由职业",
      "c": "学生",
      "e": "退休",
      "d": "无业"
    },
    "Freelance_OwnACompany": "自由职业 / 个体商业户",
    "Freelance_OwnACompany_select": {
      "0": "自由职业",
      "1": "个体商业户"
    },
    "Position": "职位",
    "FD_Position_select": {
      "0": "首席经理，例如首席行政总裁、首席财务官、首席信息官等",
      "1": "公司管理高层",
      "2": "高级/中级经理",
      "3": "部门经理",
      "4": "书记/秘书",
      "5": "一般员工",
      "6": "初级员工",
      "7": "其他（请说明）"
    },
    "Employer": "公司名称",
    "Biz_Nature": "经营范围",
    "financialRegulator": "您的雇主是否受FCA或其他金融机构监管",
    "financialRegulatorSelect": {
      "Y": "是",
      "N": "否"
    },
    "Industry_Sector": "行业",
    "Industry_Sector_select": {
      "0": "会计",
      "1": "广告媒体",
      "2": "计算机/互联网/通信/电子",
      "3": "教育/培训",
      "4": "能源/原材料",
      "5": "金融服务（金融/银行/保险)",
      "6": "政府/非营利组织",
      "7": "人力资源",
      "8": "法律",
      "9": "营销",
      "10": "物流/交通",
      "11": "制药/医疗",
      "12": "专业服务",
      "13": "房地产/建筑",
      "14": "服务业",
      "15": "贸易/消费/制造/运营",
      "16": "其他（请注明）"
    },
    "Annual_Income": "您的年总收入",
    "Annual_Income_word":"一年内所有能赚取的收入，包括薪金、养老金、利息、红利、租金等",
    "Total_Saving_Investments": "您的储蓄和投资总额",
    "Total_Saving_word": "到目前为止所有的储蓄和投资，包括银行和投资平台的存款、证券、基金、债券和其他投资等",
    "Total_Saving_Investments_select": {
      "0": "多于 US$500,000",
      "1": "US$200,000-US$499,999",
      "2": "US$100,000-US$199,999",
      "3": "US$50,000-US$99,999",
      "4": "US$25,000-US$49,999",
      "5": "US$10,000-US$24,999",
      "6": "US$2,000-US$9,999",
      "7": "少于 US$2,000"
    },
    "liquidNetWorth": "流动资金净值（不包括私人物业）",
    "financialPortfolio": "您的金融投资组合总值",
    "annualIncomeSelect": {
      "0": "多于 US$200,000",
      "1": "US$100,000-US$199,999",
      "2": "US$50,000-US$99,999",
      "3": "US$25,000-US$49,999",
      "4": "US$10,000-US$24,999",
      "5": "少于 US$10,000"
    },
    "fundsSource": "这些资金的来源",
    "fundsSourceSelect": {
      "0": "无",
      "1": "家庭或伴侣收入",
      "2": "政府福利",
      "3": "贷款/信贷",
      "4": "养老金",
      "5": "租金收入",
      "6": "其他（请注明）"
    },
    "Funds_Source": "其他收入来源",
    "Intend_Deposit": "在ATFX的预计投资额为多少美元？",
    "intendDepositSelect": {
      "0": "多于 US$100,000",
      "1": "US$80,000 – US$99,999",
      "2": "US$50,000 – US$79,999",
      "3": "US$25,000 – US$49,999",
      "4": "US$10,000 – US$24,999",
      "5": "少于 US$10,000"
    },
    "Other_Industry_Sector": "其他行业",
    "Other_Position": "其他职位",
    "Other_Biz_Nature": "其他经营范围",
    "Other_Funds_Source": "其他收入来源",
    "Afford_To_Lose_Error":"差价合约 (CFDs) 属高风险产品，您只应使用您可承受损失的资金来进行交易。",
    "Afford_To_Lose":"您可以承受您计划投入的资金出现亏损吗？",
    "Afford_To_Lose_Select": {
      "Y": "可以",
      "N": "不可以"
    },
    "Open_Trading_Account":"您为什么要在 ATFX 开立交易帐户？",
    "Open_Trading_Account_Select": {
      "0": "在金融市场进行短期至中期投机",
      "1": "透过短期至中期的对冲抵销现有的投资的风险",
      "2": "在金融市场进行短期至中期投机，同时借对冲抵销现有的投资的风险"
    },
    "ATFX_Client_Pro":"ATFX认为其产品仅适合具有上述目标的客户。如果您的目标与上述目标不同，请放弃本次申请。",
    "Annual_Income_Total":"请提供您的实际年收入",
    "Saving_Investments_Money":"请提供您的实际储蓄和投资总额",
  },
  "Experience": {
    "experienceLabel": "在过去的三年中，您根据自己的交易策略交易以下产品的次数为多少？",
    "Futures_Options": "期货/期权",
    "Futures_Options_select": {
      "0": "多于40次",
      "1": "15-40次",
      "2": "1-15 次",
      "3": "无"
    },
    "CFDs_Spread_Bets": "差价合约/外汇衍生品",
    "CFDs_Spread_Bets_select": {
      "0": "多于40次",
      "1": "15-40次",
      "2": "1-15 次",
      "3": "无"
    },
    "Derivative_Trade_over2": "在过去的十二个月里，在您自己的交易决策下，您是否每季度对现货外汇/差价合约/期权/期货中至少进行过两次交易？",
    "Derivative_Trade_over2_select": {
      "b": "是",
      "a": "否"
    },
    "Derivative_Trade_over40": "在过去三年中，您是否对现货外汇/差价合约/期权/期货在每年进行了至少四十次交易？",
    "Derivative_Trade_over40_select": {
      "b": "是",
      "a": "否"
    },
    "Average_Annual_Investment":"对于您选择的上述金融产品，您过去平均每年用于交易的投资金额是多少？",
    "Average_Annual_Investment_select": {
      "0": "未投资过该产品",
      "1": "少于500美元 ",
      "2": "500到2,500美元",
      "3": "2500到10,000美元",
      "4": "超过10,000美元"
    },
    "Average_Leverage_Level":"对于您选择的上述金融产品，您使用的平均杠杆水平是多少？",
    "Average_Leverage_Level_select": {
      "0": "未使用过杠杆",
      "1": "不超过1:10",
      "2": "1:10到1:25",
      "3": "1:25到1:50",
      "4": "1:50到1:100",
      "5": "1:100以上"
    }
  },
  "Knowledge": {
    "DT_Work_Experience": "您是否从事过金融衍生产品业务的工作并从此获得相关的产品知识？",
    "DT_Work_Experience_select": {
      "txt1": "是",
      "txt2": "否",
      "subTxt1": "我至少有3年的工作经验",
      "subTxt2": "我有不到3年的工作经验，或者至少有一年以我的个人名义投资的经验"
    },
    "DT_Qualification": "您是否有相关学位或资格证书证明您对衍生品交易有所了解？",
    "DT_Qualification_select": {
      "txt1": "是",
      "txt2": "否",
      "subTxt1": "我持有专业资格或学位，如CFA, MBA, BSC, MA等",
      "subTxt2": "我持有与金融，经济，会计或相关领域相关的证书或者学位"
    },
    "K_Sell_Position": "您在1200的价格卖出一手黄金，现在价格上涨到1300， 请判断您的这笔订单是亏损还是盈利？",
    "K_Sell_Position_b": "您在1200的价格卖出一手XAUUSD.sb，现在价格上涨到1300，请判断您的这笔订单是亏损还是盈利？",
    "K_Sell_Position_select": {
      "0": "亏损",
      "1": "盈利"
    },
    "Closing_Order": "为了防止您的账户亏损大于您的预定数额，您将通过止损还是止盈来限制损失？",
    "Closing_Order_select": {
      "0": "止损",
      "1": "止盈"
    },
    "K_Profit_Change": "您是否理解通过杠杆交易CFD产品时，高杠杆意味着高风险？",
    "K_Profit_Change_b": "您是否理解通过杠杆交易CFDs/点差产品时，高杠杆意味着高风险？",
    "K_Profit_Change_select": {
      "0": "理解",
      "1": "不理解"
    },
    "K_Margin": "在杠杆为1：20的情况下，交易一手(100,000)美元/日元的占用保证金是多少？",
    "K_Margin_select": {
      "0": "USD 5,000",
      "1": "USD 50,000",
      "2": "USD 100,000"
    }
  },
  "Acknowledgements": {
    "A1": "我确认提供给您的信息都是准确和完整的，并在此承诺该信息有任何改动会通知到您的；",
    "A2": "我已阅读，理解并同意接受AT Global Markets (UK) Limited 提供的客户协议的约束；",
    "A2_txt": "客户协议的约束",
    "A2_link": "<a href='http://www.chinese-atfx.com/uk/wp-content/uploads/sites/5/2019/04/standard-terms-uk-cn.pdf' target='_blank'>客户协议的约束</a>",
    "A3": "我已阅读，理解并同意接受AT Global Markets (UK) Limited提供的风险披露声明书的约束；",
    "A3_txt": "客户协议的约束",
    "A3_link": "<a href='http://www.chinese-atfx.com/uk/wp-content/uploads/sites/5/2019/04/standard-terms-uk-cn.pdf' target='_blank'>客户协议的约束</a>",
    "A4": "我已阅读，理解並同意接受AT GLOBAL MARKETS（英國 Limited公司提供的客戶协议执行政策和冲突政策；",
    "A4_txt": "客戶协议执行政策和冲突政策",
    "A4_link": "<a href='https://www.chinese-atfx.com/uk/wp-content/uploads/sites/5/2019/04/order-execution-policy-uk-en-1.pdf' target='_blank'>客戶协议执行政策</a>和<a href='https://www.atfx.com/uk/wp-content/uploads/conflict-of-interests-policy-uk-cn.pdf' target='_blank'>冲突政策</a>",
    "headaer": "完成提交本开户表，即确认您已明白保证金外汇及差价合约是杠杆产品, 并会为您的投资本金带来高风险。您确认已知悉监控账户情况属本人的责任，且产品性质本身导致您可能会损失超过初始投资额。",
    "age": "您确认已经年满18岁。",
    "message": "您确认提供给的信息都是准确和完整的，并在此承诺该信息有任何改动会通知到我们。",
    "receive": {
      "text": "您已阅读，理解并同意接受",
      "list": [
        "<a href='http://www.chinese-atfx.com/uk/wp-content/uploads/sites/5/2019/04/standard-terms-uk-cn.pdf' target='_blank'>商业条款及风险声明</a>",
        "<a href='https://www.chinese-atfx.com/uk/wp-content/uploads/sites/5/2019/04/order-execution-policy-uk-en-1.pdf' target='_blank'>订单执行政策</a>",
        "<a href='http://www.chinese-atfx.com/uk/wp-content/uploads/sites/5/2019/04/privacy-policy-uk-cn.pdf' target='_blank'>隐私政策</a>",
        // "<a href='https://www.atfx.com/uk/wp-content/uploads/introducing-broker-disclosure-cn.pdf' target='_blank'>介绍经纪商披露</a>",
        "<a href='https://www.atfx.com/zh-hans/legal' target='_blank'>关键信息文件</a>"
      ]
    },
    "A_select": {
      "text": "我已阅读，理解并同意以上所有条款。",
      "Y": "我已阅读，理解并同意以上所有条款。"
    },
    "checkboxTxt_A1": "我已阅读，理解并同意以上所有条款",
    "checkboxTxt_A2": "我熟悉并理解差价合约是杠杆产品，其价格波动幅度很大",
    "checkboxTxt_A3": "我熟悉并理解操作和管理我的帐户必须是我的个人行为和责任",
    "checkboxTxt_A4": "我熟悉并理解在交易杠杆产品时，损失可能会超过我的初始投资资金",
    "Marketing_Email_Preference": "我同意接收来自ATFX的资讯,其中可能包含营销的內容",
    "Marketing_automatically": "我了解我可以通过联系<a href='https://www.atfx.com/zh-hans/about-us/contact-us' target='_blank'>客户服务团队</a>立即选择不接收营销传播。",
    "Marketing_Email_Preference_select":{
      "Y":"同意",
      "N":"不同意"
    },
    "Hear_ATFX":"您是如何了解ATFX的?",
    "OtherHearATFX":"其他途径",
    "hearATFXSelect":{
      "Recommendation":"推荐",
      "SearchEngine":"搜索引擎",
      "MediaAdvertising":"媒体广告",
      "Partnership":"合作伙伴",
      "Other":"其他"
    },
    "Parent_IB_Code": "推荐人编号",
    "Rec_Type": "推荐人类型",
    "recTypeSelect": {
      "AA1": "AA1",
      "AA2": "AA2",
      "AA3": "AA3",
      "A01": "A01",
      "A02": "A02",
      "A03": "A03",
      "A00": "A00",
      "NAN": "无推荐人"
    },
    "recGroup": "组别",
    "recGroupSelect": {
      "A": "A",
      "AA": "AA"
    }
  },
  "customErrMsg": {
    "fieldIsRequired": {
      "Gender": "请选择",
      "OtherGender":"请输入其他性别",
      "Title": "请选择",
      "OtherTitle":"请输入其它称谓",
      "First_Name": "请输入名",
      "Surname": "请输入姓",
      "Email": "请输入电子邮箱",
      "Email_Confirm": "请输入电子邮件",
      "Lang": "请选择",
      "Country": "请选择",
      "MT4_Currency":"请选择",
      "Account_Type":"请选择",
      "Addr": "请输入地址",
      "Addr2": "请输入地址2",
      "City": "请输入城市名称",
      "Postcode": "请输入邮政编码",
      "Building_Name": "楼房编号/名称",
      "Street": "街道",
      "Province": "省份",
      "Birth_Date_Year": "请选择",
      "Birth_Date_Month": "请选择",
      "Birth_Date_Day": "请选择",
      "Nationality": "请选择",
      "isHavePass": "请选择",
      "NAT_ID": "请输入护照号码",
      "Phone": "请输入电话",
      "Doc_Type": "请选择",
      "Doc_No": "请输入证件号码",
      "Addr_Country": "请选择",
      "Bank_Card_No": "请输入银行卡号",
      "Bank": "请选择",
      "OtherBank": "请输入其它银行名称",
      "Beneficiary_Name": "请输入收款人",
      "Branch_Name": "请输入分行名称",
      "Bank_Addr": "请输入开户行名称",
      "Branch_Province": "请输入分行省份",
      "Branch_City": "请输入分行城市",
      "FD_Emp_Status": "请选择",
      "FD_Position": "请输入职位",
      "FD_Employer": "请输入受雇公司名称",
      "FD_Biz_Nature": "请输入业务属性",
      "FD_FCA_AUTH": "请选择",
      "FD_Annual_Income": "请选择年收入",
      "FD_Liquid_Net_Worth": "请选择",
      "FD_Portfolio_Value": "请选择",
      "FD_Funds_Source": "请选择",
      "FD_Funds_Other": "请输入这些资金的其他来源",
      "E_Forex_Exp": "请选择经验年数",
      "E_Forex_Trade_No": "请选择",
      "E_Derivative_Exp": "请选择经验年数",
      "E_Derivative_Trade_No": "请选择",
      "E_Equity_Exp": "请选择经验年数",
      "E_Equity_Trade_No": "请选择",
      "K_A": "请选择",
      "K_A_Detail": "请输入详情",
      "K_B": "请选择",
      "K_B_Detail": "请输入详情",
      "K_C": "请选择",
      "K_C_Detail": "请输入详情",
      "K_D": "请选择",
      "K_E": "请选择",
      "K_F": "请选择",
      "K_G": "请选择",
      "K_H": "请选择",
      "A1": "请选择",
      "A2": "请选择",
      "A3": "请选择",
      "A4": "请选择",
      "checkList":"请选择",
      "Emp_Status": "请选择",
      "Freelance_OwnACompany": "请选择",
      "Industry_Sector": "请选择",
      "Position": "请选择",
      "Employer": "请输入受雇公司名称",
      "Biz_Nature": "请输入业务属性",
      "Annual_Income": "请选择",
      "Total_Saving_Investments": "请选择",
      "Funds_Source": "请选择",
      "Intend_Deposit": "请选择",
      "Other_Industry_Sector": "请输入其他行业",
      "Other_Position": "请输入其他职位",
      "Other_Biz_Nature": "请输入其他经营范围",
      "Other_Funds_Source": "请输入其他收入来源",
      "Futures_Options": "请选择",
      "CFDs_Spread_Bets": "请选择",
      "Derivative_Trade_over2": "请选择",
      "Derivative_Trade_over40": "请选择",
      "DT_Work_Experience": "请选择",
      "DT_Qualification": "请选择",
      "K_Sell_Position": "请选择",
      "Closing_Order": "请选择",
      "K_Profit_Change": "请选择",
      "K_Margin": "请选择",
      "IBAN_Code":"请输入IBAN编码",
      "Hear_ATFX":"请选择",
      "OtherHearATFX":"请输入",
      "Rec_Type":"请选择",
      "Parent_IB_Code":"推荐人编号",
      "Afford_To_Lose":"请选择",
      "Open_Trading_Account":"请选择",
      "Annual_Income_Total":"请输入",
      "Saving_Investments_Money":"请输入",
      "IS_Politically_Person":"请选择",
      "isDualCitizenship":"请选择",

    }
  },
  "errors": {
    "fieldIsRequired": "请输入电子邮箱",
    "invalidFormat": "无效的格式！",
    "numberTooSmall": "该数值太小！最小值：{ 0 }",
    "numberTooBig": "该数值太大！最小值：{ 0 }",
    "invalidNumber": "无效号码",
    "textTooSmall": "文本长度太短！当前：{ 0 }，最小：{ 1 }",
    "textTooBig": "文本长度太长！当前：{ 0 }，最小：{ 1 }",
    "thisNotText": "这不是文字！",
    "thisNotArray": "这不是一个数组！",
    "selectMinItems": "选择最小{ 0 }项！",
    "selectMaxItems": "选择最大{ 0 }项！",
    "invalidDate": "无效的日期！",
    "dateIsEarly": "日期太早了！当前：{ 0 }，最小：{ 1 }",
    "dateIsLate": "日期太晚了！当前：{ 0 }，最小：{ 1 }}",
    "invalidEmail": "无效的电子邮箱地址",
    "invalidURL": "无效的URL！",
    "invalidCard": "无效的卡格式！",
    "invalidCardNumber": "无效卡号！",
    "invalidTextContainNumber": "无效的文本！不能包含数字或特殊字符。",
    "invalidTextContainSpec": "无效的文本！不能包含特殊字符",
    "incorrectComfirm": "两次输入不一致",
    "invalidBirthDate": "只允许在18-69岁(包含)的年龄段申请！",
    "invalidParentClnID": "请输入小于12位数的数字！",
    "docImgFrontSizeLimit": "证件附件(正面)不能超过2MB!",
    "docImgBackSizeLimit": "证件附件(反面)不能超过2MB!",
    "imgSizeLimit": "请选择地址证明附件图片大小应小于2MB!",
    "bankCardNoTopTwo": "银行卡号前两位数字不符合",
    "bankCardNoLnegth": "请输入16-19位的数字",
    "dayErrors1": "该年为闰年，不存在该天",
    "dayErrors2": "该年为平年，不存在该天",
    "dayErrors3": "该月不存在该天",
    "emailError": "电子邮件不合法",
    "DocTypeNoError": "证件号码格式不正确",
    "DocFrontImg": "请选择证件附件(正面)",
    "DocBackImg": "请选择证件附件(反面)",
    "ProofofAddress": "请选择地址证明附件",
    "Doc_No": "请输入证件号码",
    "Phone": "请输入电话",
    "Bank_Card_No": "请输入银行卡号",
    "Birth_Date_Second": "请输入出生日期",
    "phoneError": "电话格式有误",
    "bankNumError": "银行卡号码格式不正确",
    "numType": "请输入数字",
    "bankCodeError":"IBAN编码格式不正确"
  },
  "messages": {
    "fieldsWillBeReset": "所有输入将被重置，请确认",
    "completeTip1": "请检查您的电子邮件。谢谢",
    "completeTip2": "已完成!谢谢",
    "noCompleteTip": "抱歉，您的输入信息有误，上述操作未能成功",
    "emailAndDocInvalid": "电子邮箱已被使用",
    "phoneAndDocInvalid": "电话已被使用",
    "IBCodeInvalid": "推荐人代码有误",
    "invalidBankCardNo": "银行卡号输入有误，请检查后再提交",
    "beneficiaryName": "收款人必须与账户本人及银行卡登记名称一致",
    "employerName": "我们不会联络你雇主",
    "errors": "网络有误",
    "unSelect":"请选择",
    "selectEmpStatusTip":"由于您选择了退休，学生和无业中的一项，差价合约产品为高风险产品，为了保护您的切身利益，我们会根据您提供的其他材料审查您是否适合我们所提供的产品服务"
  },
  "ModalMsg": {
    "showModal": {
      "content": "根据您在AT Global Markets Limited（UK）Limited客户账户申请中提供的信息，我们有必要通知您差价合约(CFDs)和杠杆外汇交易可能不适合您。杠杆交易对您的资本带来高风险。公司为客户提供唯一的服务--执行，在交易时，您需要依靠自己的技能和判断力。<br/><br/><b>请注意：AT Global Markets（UK）Limited提供模拟账户，您可以根据实际市场价格进行交易，我们鼓励您在使用真实资金交易前先进行模拟账户操作。</b><br/><br/>如果您仍希望在AT Global Markets（UK）Limited开设客户账户，请通过接受以下声明来确认。",
      "checkboxTxt": "我明白差价合约(CFDs)和杠杆式外汇交易对我的资本造成了很大的风险。我能够评估所涉及的风险，并希望继续申请开设账户。",
      "errorsTxt": "请选择",
      "btn": "确定"
    },
    "showAlert": {
      "title": "提示：",
      "submitBtnTxt": "确定",
      "cancleBtnTxt": "取消",
      "confirmBtnTxt": "确定"
    }
  },
  "ratesModalMsg": {
    "p3_1": "有关零售交易者保证金率变更的通告",
    "p3_2": "尊敬的申请者：",
    "p3_2_1": "您好！",
    "p3_3": "由于欧洲证券及市场管理局（European Securities and Markets Authority，ESMA）针对零售交易者变更保证金比率，所有从2018年7月2日起在ATFX申请开户的新客户，将采用新的保证金比率。",
    "p3_4": "这些变更包括向零售交易者实施杠杆上限。",
    "p4_1": "主要外汇: 3.33%（杠杆为30:1），包括下列任何两种货币组成的货币对。美元（USD）、欧元（EUR）、日元（JPY）、 英镑（GBP）、加元（CAD）、瑞郎（CHF）",
    "p4_2": "次要外汇: 5%（杠杆为20:1），包括主要外汇组合以外的所有其他货币对。",
    "p4_3": "主要指标: 5%（杠杆为20:1），包括UK100，FRA40，ESP35，US30，SPX500，NAS100，JP225，AUS200",
    "p4_4": "黄金: 10%（杠杆为10:1）",
    "p4_5": "商品: 10%（杠杆为10:1）",
    "p5_1": "负结余保护",
    "p5_2": "ESMA推出了一项新措施，旨在确保所有零售交易者不会损失超过其账户中的可动用资金金额。假如您的账户金额变为负数，根据新规定，ATFX有义务将您的账户余额归零，而您不用支付任何费用。",
    "p5_3": "50％保证金比例平仓准则",
    "p5_4": "这项50％保证金比例平仓准则已适用于所有ATFX客户。",
    "p5_5": "如果您希望确定您的申请，并开立ATFX零售账户，请在下面的方格打勾。",
    "p5_6": "我明白并同意有关零售客户的新条款。",
    "p6_2": "请同意",
    "btnText": "提交"
  },
  "verifyMsg": {
    "phone_exist": "此电话号码已被使用，请使用其他电话号码。",
    "email_exist": "此电邮地址已被使用，请使用其他电邮地址。",
    "phoneAndemail_exist": "电话号码和电邮地址已被使用，请使用其他电话号码和电邮地址。",
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js